<template>
  <div class="menuDiv">
    <div class="my-inbox" ref="box" @click.prevent="">
      <div
        class="item"
        v-for="(item, index) in menuItems"
        :key="index"
        :id="index"
        :style="getStyle(index == currentIndex)"
        @click.prevent="clickMenuItem(index, $event)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'lz-menu',
  props: {
    menuItems: Array,
    DefaultIndex: Number,

    iColor: {
      type: String, //未选中文本颜色
      default: '#fff',
    },
    // iBgColor: { //未选中背景色
    //   type: String,
    //   default: "#fff",
    // },
    iActiveColor: {
      //选中时文本颜色
      type: String,
      default: '#fff',
    },

    // iActiveBgColor: { //选中时背景色
    //   type: String,
    //   default: "#036875",
    // },
  },
  data() {
    return {
      currentIndex: 0,
    }
  },
  beforeMount() {
    //挂着前，修改默认选项
    this.currentIndex = this.DefaultIndex
  },

  methods: {
    getStyle(select) {
      return {
        color: select ? this.iActiveColor : this.iColor,
        'font-weight': select ? 'bold' : 'normal',
        transform: select ? 'scale(1.2)' : 'scale(1)',
        background: select ? this.iActiveBgColor : this.iBgColor,
      }
    },
    clickMenuItem(idx, event) {
      let inbox = this.$refs.box

      // 点击事件传递给调用者
      if (this.currentIndex != idx) {
        this.currentIndex = idx
        // console.log("点击index: " + idx);
        this.$emit('clickLzMenuItem', this.menuItems[idx])
      }

      //滚动 到中间
      let e = event.currentTarget
      let left = e.offsetLeft - inbox.clientWidth / 2 + e.offsetWidth / 2
      inbox.scrollLeft = left
    },
  },
}
</script>

<style>
.menuDiv {
  width: 100%;
}
.menuDiv .my-inbox {
  overflow-y: hidden;
  overflow-x: scroll;
  width: 100%;
  white-space: nowrap;
}
.menuDiv .item {
  display: inline-block;
  height: 2rem;
  line-height: 2rem;
  margin: 0.5rem;
  padding: 0px 0.8rem;
  text-align: center;
  color: red;
}
.menuDiv .active {
  background-color: #036875;
  font-weight: bold;
  border-radius: 25px;
  color: #fff;
}
::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
</style>
